import React from 'react'
import PageHeader from '../components/Header'
// import UserDetail from "../components/UserDetail"
// import PageSlider from "../components/Slider"
// import WelcomePage from "../components/WelcomePage"
// import Selector from "../components/Selector"
// import FreeTrial from "../components/FreeTrial"
import PageFooter from '../components/Footer'
// import { useTranslation } from 'react-i18next'

const Privacy = () => {
  // const {t} = useTranslation('translation')

  // const dispatch = useDispatch()
  // const { userProfile } = useSelector((state) => state)
  // const debug = JSON.stringify(userProfile, null, 2)

  // const [hasRoles, setHasRoles] = useState(false)
  // const [hasAwards, setHasAwards] = useState(false)
  // const [hasAdultRanks, setHasAdultRanks] = useState(false)

  // useEffect(() => {
  //     if (userProfile.roles) { setHasRoles(true) }
  //     if (userProfile.awards) { setHasAwards(true) }
  //     if (userProfile.adultRanks) { setHasAdultRanks(true) }
  // }, [userProfile])

  return (
    <div>
      <PageHeader />

      <div id="page_header" className="page-subheader site-subheader-cst">
        <div className="bgback" />
        <div className="th-sparkles" />
        <div className="kl-bg-source">
          <div
            className="kl-bg-source__bgimage"
            style={{
              backgroundImage: 'url(images/general-bg-pc.jpg)',
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'scroll',
              backgroundPositionX: 'center',
              backgroundPositionY: 'center',
              backgroundSize: 'cover',
            }}
          />
          <div
            className="kl-bg-source__overlay"
            style={{ backgroundColor: 'rgba(53,53,53,0.1)' }}
          />
        </div>

        <div className="ph-content-wrap d-flex">
          <div className="container align-self-center">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="clearfix" />
              </div>
              <div
                className="col-sm-12 col-md-6 col-lg-6"
                style={{ backgroundColor: 'rgba(0,0,0,0.5)', padding: 15 }}
              >
                <div className="subheader-titles">
                  <h2 className="subheader-maintitle">Privacy Policy</h2>
                  <h4 className="subheader-subtitle">BJJ Levice Mobile App</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="services" className="hg_section pt-50 pb-100">
        <div className="container">
        <h1>Privacy Policy – BJJ Levice Mobile App</h1>
        <p><strong>Last updated:</strong> 20 November 2025</p>

        <p>
          This Privacy Policy explains how the mobile application <strong>BJJ Levice</strong>
          (Android app) uses and handles data on your device, especially in relation to
          the camera permission.
        </p>

        <h2>1. Who we are</h2>
        <p>
          The application is operated by <strong>BJJ Levice</strong>. For more information
          about our academy and activities, please visit{" "}
          <a href="https://bjjlevice.sk/privacy" target="_blank" rel="noopener noreferrer">
            https://bjjlevice.sk/privacy
          </a>.
        </p>

        <h2>2. Camera permission (android.permission.CAMERA)</h2>
        <p>
          The app requests access to the device camera solely for the following purposes:
        </p>
        <ul>
          <li>Scanning QR codes (for example, check-in / attendance within the academy).</li>
          <li>Capturing photos directly inside the app, if required by the user.</li>
        </ul>
        <p>
          The live camera feed is processed <strong>locally on the device</strong>. The app
          does not upload raw camera images or video streams to external servers by default.
        </p>

        <h2>3. Data collection and storage</h2>
        <p>
          In connection with camera usage, the app:
        </p>
        <ul>
          <li>does <strong>not</strong> collect biometric data,</li>
          <li>does <strong>not</strong> track the user&apos;s identity through the camera,</li>
          <li>does <strong>not</strong> share camera data with third parties for advertising or analytics.</li>
        </ul>
        <p>
          Any photos or scanned codes that are processed are used only for the intended in-app
          functionality (e.g., confirming presence) and are not sold or shared with external
          companies.
        </p>

        <h2>4. Data sharing</h2>
        <p>
          BJJ Levice does <strong>not</strong> sell, rent, or otherwise share data obtained
          via the camera with third-party advertisers or data brokers. Where the application
          communicates with our backend systems (for example, to register attendance), only the
          minimum necessary information is transmitted.
        </p>

        <h2>5. Children&apos;s privacy</h2>
        <p>
          The application may be used by children as part of training activities at BJJ Levice,
          typically under the supervision of parents or guardians. We do not intentionally
          collect personal data from children beyond what is necessary for the operation of the
          training and attendance systems.
        </p>

        <h2>6. Your choices</h2>
        <p>
          You can manage camera permissions at any time in your Android device settings:
        </p>
        <ul>
          <li>Open <strong>Settings &gt; Apps</strong>,</li>
          <li>find the <strong>BJJ Levice</strong> app,</li>
          <li>go to <strong>Permissions</strong> and enable or disable the camera permission.</li>
        </ul>
        <p>
          If you disable the camera permission, features that rely on the camera (such as
          QR code scanning) may not work correctly.
        </p>

        <h2>7. Changes to this policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in the app,
          legal requirements, or our practices. The most recent version will always be available
          at{" "}
          <a href="https://bjjlevice.sk/privacy" target="_blank" rel="noopener noreferrer">
            https://bjjlevice.sk/privacy
          </a>.
        </p>

        <h2>8. Contact</h2>
        <p>
          If you have any questions about this Privacy Policy or how the app uses the camera
          and other permissions, please contact:
        </p>
        <p>
          <strong>BJJ Levice</strong>
          <br />
          E-mail: <a href="mailto:info@bjjlevice.sk">info@bjjlevice.sk</a>
          <br />
          Website:{" "}
          <a href="https://bjjlevice.sk" target="_blank" rel="noopener noreferrer">
            https://bjjlevice.sk
          </a>
        </p>
      </div>
      </section>

      <PageFooter />
    </div>
  )
}

export default Privacy
